class ArticleRecommendationComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
    this.movecontent();
  }

  initPages() {
    var productSplide = new Splide(
      this.querySelector('.content-block .splide'),
      {
        perPage: 1,
        gap: 0,
        arrows: true,
        pagination: false,
        role: '',
        autoHeight: true,
      }
    );
    var bannerSplide = new Splide(this.querySelector('.banner-block .splide'), {
      perPage: 1,
      arrows: true,
      pagination: false,
    });
    productSplide.sync(bannerSplide);
    productSplide.mount();
    bannerSplide.mount();
  }
  movecontent() {
    var placeholder = document.querySelector(
      '.article-template__content .move-here'
    );
    placeholder.append(this);
  }
}

customElements.define(
  'article-recommendation-component',
  ArticleRecommendationComponent
);

class FeaturedArticles extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }

  initPages() {
    var content = this.querySelector('.splide');
    if (content != undefined) {
      if (
        content.classList.contains('mobile-style--slider') &&
        window.innerWidth < 989
      ) {
        this.gallerySplide = new Splide(this.querySelector('.splide'), {
          perPage: 3,
          gap: 20,
          arrows: true,
          pagination: false,
          role: '',
          breakpoints: {
            989: {
              perPage: 2,
              gap: 20,
            },
            480: {
              padding: { right: 30 },
              perPage: 1,
              gap: 20,
            },
          },
        });

        this.gallerySplide.mount();
      }
    }
  }
}

customElements.define('featured-articles', FeaturedArticles);

class CollapedContent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }

  initPages() {
    var content = this.querySelector('.splide');
    if (
      content.classList.contains('mobile-style--slider') &&
      window.innerWidth < 989
    ) {
      this.gallerySplide = new Splide(this.querySelector('.splide'), {
        perPage: 3,
        gap: 20,
        arrows: true,
        pagination: false,
        role: '',
        breakpoints: {
          989: {
            perPage: 2,
            gap: 20,
          },
          480: {
            padding: { right: 30 },
            perPage: 1,
            gap: 20,
          },
        },
      });
      this.gallerySplide.mount();
    }

    var articles = this.querySelectorAll('.blog__post');
    var $this = this;
    this.querySelector('.ToggleButton').addEventListener('click', function (e) {
      e.preventDefault();
      if ($this.gallerySplide != undefined) {
        $this.gallerySplide.destroy();
      }

      articles.forEach((article) => {
        article.classList.add('splide__slide');
      });

      if ($this.gallerySplide != undefined) {
        $this.gallerySplide.mount();
      }
    });
  }
}

customElements.define('collaped-content', CollapedContent);

class BlogPagination extends HTMLElement {
  constructor() {
    super();
    this.contents = this.querySelectorAll('.blog-list');
    this.pagination = this.querySelector('.pagination');
    this.prev_num = this.querySelector('.prev_link');
    this.nex_num = this.querySelector('.next_link');
    this.initPages();
  }

  initPages() {
    var $this = this;
    this.nex_num.addEventListener('click', function (e) {
      e.preventDefault();
      var rect = document.querySelector('.main-blog').getBoundingClientRect();
      var rect_doc = document.querySelector('body').getBoundingClientRect();
      var pos = Math.abs(rect_doc.top) - Math.abs(rect.top) - 100;
      var pageNum = e.target.dataset.pageNum;
      var limit = e.target.dataset.limit;
      var nextNum = parseInt(pageNum) + 1;
      if (nextNum > limit) {
        e.target.classList.add('disable');
      } else {
        e.target.classList.remove('disable');
      }
      $this.prev_num.classList.remove('disable');
      e.target.dataset.pageNum = nextNum;
      $this.prev_num.dataset.pageNum = parseInt(pageNum) - 1;
      $this.contents.forEach((content) => {
        content.classList.remove('active');
        var currntpageNum = content.dataset.pageNum;
        if (currntpageNum == pageNum) {
          content.classList.add('active');
        }
      });
      window.scrollTo(0, pos);
    });
    this.prev_num.addEventListener('click', function (e) {
      e.preventDefault();
      var rect = document.querySelector('.main-blog').getBoundingClientRect();
      var rect_doc = document.querySelector('body').getBoundingClientRect();
      var pos = Math.abs(rect_doc.top) - Math.abs(rect.top) - 100;
      var pageNum = e.target.dataset.pageNum;
      var nextNum = parseInt(pageNum) - 1;
      if (nextNum == 0) {
        e.target.classList.add('disable');
      } else {
        e.target.classList.remove('disable');
      }
      $this.nex_num.classList.remove('disable');
      e.target.dataset.pageNum = nextNum;
      $this.nex_num.dataset.pageNum = parseInt(pageNum) + 1;
      $this.contents.forEach((content) => {
        content.classList.remove('active');
        var currntpageNum = content.dataset.pageNum;
        if (currntpageNum == pageNum) {
          content.classList.add('active');
        }
      });
      window.scrollTo(0, pos);
    });
    $this.contents.forEach((content) => {
      if (content.querySelector('.first-block .splide') != undefined) {
        var firstSplide = new Splide(
          content.querySelector('.first-block .splide'),
          {
            perPage: 2,
            gap: 50,
            arrows: true,
            pagination: false,
            role: '',
            breakpoints: {
              480: {
                padding: { right: 30 },
                perPage: 1,
                gap: 20,
              },
            },
          }
        );

        firstSplide.mount();
      }

      if (content.querySelector('.last-block .splide') != undefined) {
        var lastSplide = new Splide(
          content.querySelector('.last-block .splide'),
          {
            perPage: 2,
            gap: 50,
            arrows: true,
            pagination: false,
            role: '',
            breakpoints: {
              480: {
                padding: { right: 30 },
                perPage: 1,
                gap: 20,
              },
            },
          }
        );

        lastSplide.mount();
      }
    });
  }
}

customElements.define('blog-pagination', BlogPagination);
